<template>
  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width"> 
          <div slot="header">
            <h4 class="card-title">Histórico de Estoque</h4>
            <p style="color: #aaa">Selecione um produto para mostrar o seu histórico de movimentações</p>
          </div>

          <div slot="raw-content">
            <div class="p-3">
              <v-select label="descricao" v-model="produto_selecionado" @input="reload(false)" :clearable="false" :options="produtos"></v-select>

              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Cód.</th>
                    <th>Data</th>
                    <th>Hora</th>
                    <th>Operação</th>
                    <th>Origem</th>
                    <th>Qtd</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="movimento of movimentos">
                    <td>{{ movimento.codigo }}</td>
                    <td>{{ movimento.data | moment('DD/MM/YYYY') }}</td>
                    <td>{{ movimento.data | moment('HH:mm:ss') }}</td>
                    <td>{{ movimento.operacao }}</td>
                    <td :style="`color: ${movimento.color}`">{{ movimento.origem }}</td>
                    <td>{{ movimento.quantidade }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="row">
                <div class="col-12 col-md-6 text-center-mobile">
                  Mostrando de {{ from }} até {{ to }} de {{ total }} registros
                </div>
                <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
                  <paginate
                  v-model="current_page"
                  :pageCount="pageCount"
                  :clickHandler="changePage"
                  :prevText="'Ante.'"
                  :nextText="'Próx.'"
                  :containerClass="'pagination'">
                  </paginate>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
  import moment from 'moment'
  import ProdutoService from '@/services/ProdutoService.js'
  import { http } from '@/services/HttpService.js'
  import { EventBus } from '@/services/EventBus'

  export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        produtos: [],
        movimentos: [],
        produto_selecionado: null,
        current_page: 1,
        pageCount: 0,
        cadastro: false,
        produto: {},
        categorias: [],
        from: 0,
        to: 0,
        total: 0,
      }
    },
    methods:{
      reload(same = false) {
        if(!same) {
          this.current_page = 1
        }

        if(this.produto_selecionado) {
          let loader = this.$loading.show()

          ProdutoService.historico(this.produto_selecionado.codigo, `?inverse=true&page=${this.current_page}`).then(res => {
            loader.hide()
            let movimentos = res.data.data;

            for(let movimento of movimentos) {
              movimento.origem = this.getOperacaoLabel(movimento)
              movimento.operacao = this.getOrigemLabel(movimento)
              movimento.color = this.getOperacaoColor(movimento)
            }

            this.movimentos = movimentos

            this.pageCount = res.data.last_page
            this.from = res.data.from
            this.to = res.data.to
            this.total = res.data.total
          })
          .catch(err => {
            loader.hide()
            console.error(err)
          })
        }
      },
      getOrigemLabel(movimento) {
        switch(movimento.tipo_origem) {
          case 'PVE':
          case 'PVC':
          case 'PV':
            return 'Venda';

          case 'AE':
          case 'AS':
            return 'Ajuste';

          case 'NCE':
          case 'NCC':
          case 'NF':
          case 'NFC':
            return 'Nota de Compra';

          case 'NFE':
          case 'NFS':
            return 'Nota Emitida';
        }
      },

      // AE - ajuste de entrada
      // NF - nota de compra entrada
      // NFE - nota emitida entrada
      // PVC - venda entrada
      // PVE - venda entrada
      // NCE - nota de compra entrada
      // NFC - nota de compra


      // NCC - nota de compra cancelada
      // AS - ajuste de saída
      // NFS - nota emitida saída
      // PV - venda saída
      
      

      getOperacaoColor(movimento) {
        switch(movimento.tipo_origem) {
          case 'AE':
          case 'NF':
          case 'NFE':
          case 'NFC':
          case 'PVC':
          case 'NCE':
          case 'PVE':
            return 'green';

          case 'AS':
          case 'NCC':
          case 'NFS':
          case 'PV':
            return 'red';
        }
      },
      getOperacaoLabel(movimento) {
        switch(movimento.tipo_origem) {
          case 'AE':
          case 'NF':
          case 'NFE':
          case 'NFC':
          case 'PVC':
          case 'NCE':
          case 'PVE':
            return 'Entrada';

          case 'AS':
          case 'NCC':
          case 'NFS':
          case 'PV':
            return 'Saída';
        }
      },
      loadProdutos() {
        ProdutoService.loadAll().then(res => {
          this.produtos = res.data          
        })
      },
      changePage(page) {
        this.current_page = page
        this.reload(true)
      },
    },
    mounted() {
      this.loadProdutos()
    }
  }
</script>


<style>
  .img-preview {
    max-width: 100%;
    max-height: 100%;
    display: block;
  }

  .loading-upload {
    opacity: 0.3
  }

  .fileinput {
    display: none !important;
  }
</style>